<template>
	<section class="pool-index mt-3">
		<div class="row">
			<div class="col">
				<h1 class="mb-0">Pools</h1>
				<p class="mb-0">Earn yield on trading fees by providing liquidity</p>
			</div>
			<div class="col-auto mt-2">
				<router-link class="btn btn-white" to="/app/pools/create"
				><i class="fa fa-plus"></i> Create Pool
				</router-link
				>
			</div>
		</div>

		<div class="card animate__animated animate__fadeIn mt-3">
			<div class="card-header">
				<div class="flex max-md:flex-col gap-2">
					<label class="field-group w-full">
						<input
							v-model="sVal"
							class="input"
							placeholder="Search"
							@input="onSearch"
						/>
					</label>
					<label class="field-group max-md:w-full whitespace-nowrap !flex-nowrap before:!hidden after:!hidden">
            <span class="addon w-full">
              <input v-model="verifiedOnly" type="checkbox" class="switch !align-middle !m-0 !mr-2"/>
              Verified Tokens
            </span>
					</label>
				</div>
			</div>
			<div class="card-body">
				<div v-if="loading">
					<h4 v-if="sVal.length === 0" class="text-center my-5 py-5">
						Loading Pools
					</h4>
					<h4 v-else class="text-center my-5 py-5">Searching Pools</h4>
				</div>

				<div v-else-if="items.length === 0">
					<h4 class="text-center my-5 py-5">No pools found</h4>
				</div>
				<table class="table animate__animated animate__fadeIn" v-else>
					<thead>
					<tr>
						<td class="w-auto w-lg-25">Pair</td>
						<td>Pool</td>
						<td class="d-none d-md-table-cell w-25">Token A</td>
						<td class="d-none d-md-table-cell w-25">Token B</td>
						<!--						<td>LP Token</td>-->
						<td class="d-none d-lg-table-cell">Type</td>
					</tr>
					</thead>
					<tbody>
					<PoolRow
						class="animate__animated animate__fadeIn"
						v-for="item in items"
						:key="item.address"
						:pool="item"
					></PoolRow>
					</tbody>
				</table>
			</div>
			<div class="card-footer">
				<button
					:disabled="page <= 0"
					class="btn btn-white btn-sm"
					@click="prevPage"
				>
					Prev
				</button>
				<button
					:disabled="items.length < limit"
					class="btn btn-white btn-sm float-end"
					@click="nextPage"
				>
					Next
				</button>
			</div>
		</div>
	</section>
</template>

<script>
import PoolRow from "@/components/pools/PoolRow.vue";

export default {
	name: "PoolIndex",
	components: {PoolRow},
	data() {
		return {
			loading: false,
			items: [],
			limit: 25,
			page: 0,

			verifiedOnly: false,
			searchTimeout: null,
			sVal: "",
		};
	},
	watch: {
		verifiedOnly: function () {
			this.page = 0;
			this.loadPools();
		},
	},
	methods: {
		onSearch: function () {
			this.debounce(() => {
				if (this.sVal.length >= 3) {
					this.loadPools();
				} else {
					this.searchTokens = [];
				}
			}, 400);
		},
		debounce: function (func, wait) {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => func(), wait);
		},

		doSearch: function () {
			console.log("Searching", this.sVal);
			this.$store.state.solana.fluxClient
				.searchPools(this.sVal, this.page, this.limit, this.verifiedOnly)
				.then((r) => {
					this.items = r || [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		loadPools: function () {
			this.items = [];
			this.loading = true;

			if (this.sVal.length > 1) return this.doSearch();

			return this.getItems();
		},

		getItems: function () {
			this.loading = true;
			this.$store.state.solana.fluxClient
				.getPools(this.page, this.limit, this.verifiedOnly)
				.then((r) => {
					this.items = r || [];
				})
				.finally(() => {
					this.loading = false;
				});
		},
		nextPage: function () {
			this.page++;

			if (this.page < 0) this.page = 0;

			this.loadPools();
		},
		prevPage: function () {
			this.page--;
			if (this.page < 0) this.page = 0;

			this.loadPools();
		},
	},
	mounted() {
		this.loadPools();
	},
};
</script>

<style scoped>
.card {
	min-height: 80vh;
}

tbody tr:hover {
	background: var(--bs-dark);
	cursor: pointer;
}
</style>
